<template>
  <div>
    <div class="item products-wrap">
      <table class="mt-5 products">
        <tr>
          <th></th>
          <th>Veículo</th>
          <th>Versão</th>
          <th class="year-column" @click="orderCarsBy('year_from')">
            Ano de
            <i class="fas fa-angle-down" :class="flipYearFromArrow && 'fa-rotate-180'"></i>
          </th>
          <th class="year-column" @click="orderCarsBy('year_to')">
            Ano até
            <i class="fas fa-angle-down" :class="flipYearToArrow && 'fa-rotate-180'"></i>
          </th>
          <th>Motor</th>
          <th>Ar</th>
          <th>Óleo</th>
          <th>Combustível</th>
          <th>Cabine</th>
          <th>Câmbio</th>
        </tr>
        <tr v-for="car in vehicles" :key="car.objectID">
          <td class="img">
            <img :src="car.thumb ? (url + car.thumb) : '../../static/images/prod3.png'" alt>
            <span>
              <img :src="car.thumb ? (url + car.thumb) : '../../static/images/prod3.png'" alt>
            </span>
          </td>
          <td><router-link target="_blank" :to="'/carro/' + car.vehi_id">{{car.model}}</router-link></td>
          <td>{{car.version}}</td>
          <td>{{car.year_from}}</td>
          <td>{{car.year_to}}</td>
          <td>{{car.engine}}</td>

          <td class="part-cell">
            <div
              v-for="part in car.parts"
              :key="`part-${part.parts.id}`"
            >
              <div
                class="px-3 py-1 d-flex justify-content-between align-items-center"
                v-if="part.parts && part.parts.part_subcategory_id == 1"
              >
                <router-link
                  class="w-auto h-auto p-0 min-w-auto img"
                  :class="{'mr-2': part.parts.details}"
                  target="_blank"
                  :to="'/produto/' + part.parts.code"

                >{{part.parts.code}}
                  <span class="pointer">
                    <img :src="url + part.parts.img" alt>
                  </span>
                </router-link>
                <tooltip v-if="part.parts.details">
                  {{ part.parts.details }}
                </tooltip>
              </div>
            </div>
          </td>

          <td class="part-cell">
            <div
              v-for="part in car.parts"
              :key="`part-${part.parts.id}`"
            >
              <div
                class="px-3 py-1 d-flex justify-content-between align-items-center"
                v-if="part.parts && part.parts.part_subcategory_id == 3"
              >
                <router-link
                  class="w-auto h-auto p-0 min-w-auto img"
                  :class="{'mr-2': part.parts.details}"
                  target="_blank"
                  :to="'/produto/' + part.parts.code"

                >{{part.parts.code}}
                  <span class="pointer">
                    <img :src="url + part.parts.img" alt>
                  </span>
                </router-link>
                <tooltip v-if="part.parts.details">
                  {{ part.parts.details }}
                </tooltip>
              </div>
            </div>
          </td>

          <td class="part-cell">
            <div
              v-for="part in car.parts"
              :key="`part-${part.parts.id}`"
            >
              <div
                class="px-3 py-1 d-flex justify-content-between align-items-center"
                v-if="part.parts && part.parts.part_subcategory_id == 4"
              >
                <router-link
                  class="w-auto h-auto p-0 min-w-auto img"
                  :class="{'mr-2': part.parts.details}"
                  target="_blank"
                  :to="'/produto/' + part.parts.code"

                >{{part.parts.code}}
                  <span class="pointer">
                    <img :src="url + part.parts.img" alt>
                  </span>
                </router-link>
                <tooltip v-if="part.parts.details">
                  {{ part.parts.details }}
                </tooltip>
              </div>
            </div>
          </td>

          <td class="part-cell">
            <div
              v-for="part in car.parts"
              :key="`part-${part.parts.id}`"
            >
              <div
                class="px-3 py-1 d-flex justify-content-between align-items-center"
                v-if="part.parts && part.parts.part_subcategory_id == 2"
              >
                <router-link
                  class="w-auto h-auto p-0 min-w-auto img"
                  :class="{'mr-2': part.parts.details}"
                  target="_blank"
                  :to="'/produto/' + part.parts.code"

                >{{part.parts.code}}
                  <span class="pointer">
                    <img :src="url + part.parts.img" alt>
                  </span>
                </router-link>
                <tooltip v-if="part.parts.details">
                  {{ part.parts.details }}
                </tooltip>
              </div>
            </div>
          </td>

          <td class="part-cell">
            <div
              v-for="part in car.parts"
              :key="`part-${part.parts.id}`"
            >
              <div
                class="px-3 py-1 d-flex justify-content-between align-items-center"
                v-if="part.parts && part.parts.part_subcategory_id == 17"
              >
                <router-link
                  class="w-auto h-auto p-0 min-w-auto img"
                  :class="{'mr-2': part.parts.details}"
                  target="_blank"
                  :to="'/produto/' + part.parts.code"

                >{{part.parts.code}}
                  <span class="pointer">
                    <img :src="url + part.parts.img" alt>
                  </span>
                </router-link>
                <tooltip v-if="part.parts.details">
                  {{ part.parts.details }}
                </tooltip>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { isoToMmYyyy, isoToFullYear } from "@/utils/date.js";
import Tooltip from "@/components/Tooltip.vue";

export default {
  components: { Tooltip },
  props: {
    cars: {
      type: Array,
      default: []
    },
    flipYearFromArrow: {
      type: Boolean,
      default: false
    },
    flipYearToArrow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      url: "https://static.japanparts.com.br",
      vehicles: []
    };
  },
  mounted() {
    this.formatVehicleYear();
  },

  methods: {
    formatVehicleYear() {
      const formatter = (date, nullReplacer) => {
        if (date) {
          const month = new Date(date).getUTCMonth() + 1;

          if (month === 1) {
            return isoToFullYear(date, nullReplacer);
          }
        }

        return isoToMmYyyy(date, nullReplacer);
      };

      this.vehicles = this.cars.map(vehicle => {
        return Object.assign({}, vehicle, {
          year_from: formatter(vehicle.year_from, "<--"),
          year_to: formatter(vehicle.year_to, "-->")
        });
      });
    },

    orderCarsBy(column) {
      this.$emit("update:vehicleTable", column);
    }
  }
};
</script>
<style scoped lang="scss">
.min-w-auto {
  min-width: auto;
}

a {
  cursor: pointer;
}
a:not([href]):not([tabindex]) {
  color: #ccb025;
}

a:not([href]):not([tabindex]):hover,
a:not([href]):not([tabindex]):focus {
  color: #0056b3;
}

.part-cell {
  border-style: dotted;
  border-width: thin;
  border-color: gray;
}

.year-column:hover {
  text-decoration: underline;
  cursor: pointer;
}

@media (max-width: 980px) {
  .products-wrap {
    overflow-x: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CarsList.vue